module.exports = __webpack_public_path__ + "img/year_book.63db30b4.jpg";